import * as React from 'react';
import { useBaseTitleLayout } from '../hooks/useBaseTitleLayout';
import { TitleLayoutProps } from '../TitleLayout.props';

// noinspection JSUnusedGlobalSymbols
export default (props: TitleLayoutProps) => {
  const {
    baseSubnavDataMap,
    BaseTitleLayout,
    HomeEntertainmentSection,
    ImageGallerySection,
    TitleAboutSection,
    VideoCarouselSection,
  } = useBaseTitleLayout(props, 'app:layout:VideoGameTitleLayout');

  const subnavData = [
    baseSubnavDataMap.TitleAboutSection,
    baseSubnavDataMap.HomeEntertainmentSection,
    baseSubnavDataMap.VideoCarouselSection,
    baseSubnavDataMap.ImageGallerySection,
  ];

  return (
    <BaseTitleLayout subnavData={subnavData}>
      <TitleAboutSection />
      <HomeEntertainmentSection />
      <VideoCarouselSection />
      <ImageGallerySection />
    </BaseTitleLayout>
  );
};
